/**
 * @bref    Fonctionnalitées jQuery relatives au formulaire des Utilisateurs.
 * @remark  Fichier appelé dans un bloc jQuery.
 */
require('../functions/AppAjax.class');
let AppAjax = window.AppAjax;

//#####################################################
// Disabling phone / fax from selected role
//#####################################################

/**
 * @brief   Actualisation des champs Adresse et Téléphone
 * @param   string  role : nom du rôle [admin, supervisor, employee, contact]
 * @param   string  form : selector de la balise <FROM>
 */
function updateAddressPhoneItemsFromSelectedRole(role, formId) {
    let isDisabled = false;
    if (role === '' || role === 'admin' || role === 'supervisor') {
        $(formId + ' select[name=address]').val('');
        $(formId + ' input[name^=phone]').val('');
        $(formId + ' input[name=fax]').val('');
        isDisabled = true;
    }
    $(formId + ' button.add-address-btn').prop('disabled', isDisabled);
    $(formId + ' select[name=address]').prop('disabled', isDisabled);
    $(formId + ' input[name^=phone]').prop('disabled', isDisabled);
    $(formId + ' input[name=fax]').prop('disabled', isDisabled);
}

$('select[name=role]').on('change', function(event) {
    event.stopPropagation();

    // Récupération du sélecteur du formulaire en cours
    let formId = 'form#' + $(event.target).parents('form:first').attr('id');

    // Récupération du rôle sélectionné
    let role = $(formId).find("option:selected").val();
    updateAddressPhoneItemsFromSelectedRole(role, formId);
});

//#####################################################
// Clear modale content when add user
//#####################################################
$('button.add-user-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-add-user input:not([type=hidden])').each(function() { $(this).val(''); });
    $('form#confirm-add-user select option:selected').each(function() { $(this).prop('selected', false); });
    $('form#confirm-add-user select[name=role]').change();
    // Réinitialisation de la validation du mot de passe
    $('form#confirm-add-user .password-check').text('');
    $('form#confirm-add-user button[type=submit]').prop('disabled', false);
});

//#####################################################
// Send user informations to the update modale
//#####################################################
$('button.update-user-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-update-user').attr('action', $(this).data('url'));
    // Modal user data
    $('form#confirm-update-user input[name=firstname]').val($(this).data('firstname'));
    $('form#confirm-update-user input[name=lastname]').val($(this).data('lastname'));
    $('form#confirm-update-user input[name=email]').val($(this).data('email'));

    let role = $(this).data('role');
    $('form#confirm-update-user select[name=role]').find('option[value="' + role + '"]')
        .prop('selected', true)
        .prop('readonly', true);

    let client_id = $(this).data('client_id');
    $('form#confirm-update-user select[name=client_id]').find('option[value="' + client_id + '"]')
        .prop('selected', true)
        .prop('readonly', true);

    let language = $(this).data('language');
    $('form#confirm-update-user select[name=language]').find('option[value="' + language + '"]')
        .prop('selected', true);

    let address = $(this).data('address');
    $('form#confirm-update-user select[name=address]').find('option[value="' + address + '"]')
        .prop('selected', true);

    $('form#confirm-update-user input[name=phone]').val(AppAjax.formatPhoneNumber($(this).data('phone')));
    $('form#confirm-update-user input[name=phone_ext]').val($(this).data('phone_ext'));
    $('form#confirm-update-user input[name=fax]').val(AppAjax.formatPhoneNumber($(this).data('fax')));

    // Champ caché
    $('form#confirm-update-user input[name=user_id]').val($(this).data('user_id'));

    // Verrouillage des champs Téléphone/Fax selon le rôle
    updateAddressPhoneItemsFromSelectedRole(role, 'form#confirm-update-user');
});

//#####################################################
// Send delete user url to the modale form action
//#####################################################
$('button.delete-user-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-delete-user').attr('action', $(this).data('url'));
});

//#####################################################
// Send disable user url to the modale form action
//#####################################################
$('button.disable-user-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-disable-user').attr('action', $(this).data('url'));
});

//#####################################################
// Send change password user url the modale form action
//#####################################################
$('button.change-password-btn').on('click', function(event) {
    event.stopPropagation();
    $('form#confirm-change-password').attr('action', $(this).data('url'));
    // Réinitialisation de la validation du mot de passe
    $('form#confirm-change-password .password-check').text('');
    $('form#confirm-change-password button[type=submit]').prop('disabled', false);
});

//#####################################################
// Set message error if password is not the same
//#####################################################
$('input[type=password]').on('input', function(event) {
    event.stopPropagation();
    let $form     = $(this).parents('form:first');
    let $alert    = $form.find('.password-check');
    let password  = $form.find('input[name=password]').val();
    let $submit   = $form.find('button[type=submit],input[type=submit]');
    $submit.prop('disabled', true);
    if (password === $form.find('input[name=confirm_password]').val()) {
        let check = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\?@#\$%\^&\*\>\<\.\:\;\(\)\_\-\~]).{8,}$");
        if (check.test(password)) {
            $alert.text('');
            $submit.prop('disabled', false);
        } else {
            $alert.html(window.lang === 'fr' ? '<ul>Le mot de passe doit comprendre au moins 8 caractères composé <li>de lettres minuscules (a-z) et majuscules (A-Z),</li><li>de chiffres (0-9) et un caractère spécial (!?@#$%^&*<>.:;_-~)</li></ul>' : '<ul>The password must contain at least 8 characters consisting of</li><li>lowercase (a-z) and uppercase (A-Z) letters,</li><li>numbers (0-9) and one special character (!?@#$%^&*<>.:;_-~)</li></ul>');
        }
    } else {
        $alert.text(window.lang === 'fr' ? 'Le mot de passe doit être identique' : 'Password must be the same');
    }
});
